import { Popover, Tag } from "antd";
import { getFormattedDate } from "modules/utilities/utility";
import moment from "moment";
import { InfoCircleOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";
import { useMemo } from "react";
import _ from "lodash";
import AdvanceTableWrapper from "modules/common/advance-table/AdvanceTableWrapper";
import AdvanceTable from "modules/common/advance-table/AdvanceTable";
import NoData from "assets/svgs/no_data/NoData";

function Orders({ customer, orders }) {
  const tableData = useMemo(() => {
    return orders?.length
      ? orders?.map((item, index) => {
          return {
            index: orders?.length - index,
            line_items: _.get(item, "order_meta.line_items", []),
            shipping_adresss: _.get(item, "order_meta.billing_address", {}),
            discount_code: _.get(item, "discount_code", {}),
            order: item,
          };
        })
      : [];
  }, [orders]);

  const columns = [
    {
      accessor: "index",
      Header: "Index",
      headerProps: { className: "text-900" },
    },
    {
      accessor: "",
      Header: "Order",
      headerProps: { className: "text-900" },
      Cell: (rowData) => {
        const { order } = rowData.row.original;
        return (
          <div className="word-break">
            <p className="fw-bold">{order?.order_display_id}</p>
            {order?.order_type && (
              <Popover content="order type" placement="right">
                <Tag
                  color="blue"
                  className="text-capitalize {tagStyle} mb-2"
                  bg="success"
                >
                  <span>{order?.order_type.replaceAll("_", " ")}</span>
                </Tag>
              </Popover>
            )}
            {order?.order_source && (
              <Tag color="green" className={tagStyle}>
                <span>{order?.order_source.toUpperCase()}</span>
              </Tag>
            )}
            {order?.is_subscription && (
              <Tag color="volcano" className={tagStyle}>
                <span>Subscription Order {subscriptionPlatform}</span>
              </Tag>
            )}
            {order?.bulk_order && (
              <Tag color="orange" className={tagStyle}>
                <span>Bulk Order ({order?.duration} months)</span>
              </Tag>
            )}
            {order?.is_single_order && (
              <Tag color="lime" className={tagStyle}>
                <span>Single Order</span>
              </Tag>
            )}
            {order?.is_combo && (
              <Tag color="blue">
                <span>Combo Order</span>
              </Tag>
            )}

            {order?.sub_status && (
              <div>
                <Tag color="geekblue">
                  <span>{order?.sub_status.toUpperCase()}</span>
                </Tag>
              </div>
            )}
            {order?.order_meta?.total_price && (
              <div>
                <Tag color="green" className={tagStyle}>
                  <span>
                    Payable Amount:{" "}
                    {String(order?.order_meta?.total_price).toUpperCase()} INR
                  </span>
                </Tag>
              </div>
            )}
            {order?.order_meta?.total_discounts && (
              <div>
                <Tag color="orange" className={tagStyle}>
                  <span>
                    Discount Amount :{" "}
                    {String(order?.order_meta?.total_discounts).toUpperCase()}{" "}
                    INR
                  </span>
                </Tag>
              </div>
            )}
            {!isEmpty(order?.order_meta?.payment_gateway_names) && (
              <div>
                <Tag color="blue" className={tagStyle}>
                  <span>
                    {order?.order_meta?.payment_gateway_names?.map((source) => {
                      return `${source} `;
                    })}
                  </span>
                </Tag>
              </div>
            )}
            <Tag color="volcano" className={tagStyle}>
              <span>
                {order?.status && order?.status.replace("_", " ").toUpperCase()}{" "}
                {order?.status === "delivered" &&
                  order?.delivery_date &&
                  moment(order?.delivery_date).format("DD-MMM-YYYY")}
              </span>
            </Tag>
            <Tag
              key={order?.status}
              color="purple"
              className={`${tagStyle} fs-1 rounded-circle p-1 pt-0`}
            >
              <Popover placement="top" content={content(order)} trigger="click">
                <InfoCircleOutlined />
              </Popover>
            </Tag>
            {order?.order_warehouse?.warehouses?.name && (
              <div>
                <Tag color="blue" className={tagStyle}>
                  <span>{order?.order_warehouse?.warehouses?.name}</span>
                </Tag>
              </div>
            )}
            {order?.is_prozo_invoiced === true && (
              <div>
                <Tag color="cyan" className={tagStyle}>
                  <span>PROZO INVOICED</span>
                </Tag>
              </div>
            )}
            <p className="mb-0 m-2">{getFormattedDate(order?.created_at)}</p>
          </div>
        );
      },
    },
    {
      accessor: "email",
      Header: "Product Name",
      headerProps: { className: "text-900" },
      Cell: (rowData) => {
        const { order } = rowData.row.original;
        return (
          <div className="">
            <ul>
              {order?.order_meta?.line_items?.map((product, index) => (
                <li key={index} className="text-break text-wrap">
                  {product?.name}
                  {` (${product?.quantity})`}
                </li>
              ))}
            </ul>
            <Popover
              placement="right"
              content={
                <div>
                  <div>
                    Shipping Address : <br />
                    {order?.order_meta?.billing_address?.address1},
                    {order?.order_meta?.billing_address?.address2},<br />
                    {order?.order_meta?.billing_address?.city},
                    {order?.order_meta?.billing_address?.province},
                    {order?.order_meta?.billing_address?.zip}
                  </div>
                </div>
              }
            >
              <span className="cursor-pointer">
                <Tag color="green">Shipping Address</Tag>
              </span>
            </Popover>
            <div className="">
              <span className="text-break text-wrap">
                Discount applied :
                {order?.discount_code ? (
                  <span className="d-flex justify-content-start">
                    {order?.discount_code} | {order?.discount_amount} |
                    {order?.discount_type}
                  </span>
                ) : (
                  <span>none</span>
                )}
              </span>
            </div>
          </div>
        );
      },
    },
  ];

  const content = (record) => {
    return (
      <div>
        <p>
          <strong>Tracking ID</strong>:{" "}
          {record?.tracking_id !== null ? record?.tracking_id : "None"}
        </p>
        <p>
          <strong>Tracking URL</strong>:{" "}
          {record?.tracking_url !== null ? record?.tracking_url : "None"}
        </p>
      </div>
    );
  };
  const tagStyle = "text-wrap word-break m-1";
  return (
    <div style={{ maxHeight: "26rem", overflowY: "scroll" }}>
      {tableData?.length ? (
        <AdvanceTableWrapper columns={columns} data={tableData}>
          <AdvanceTable
            table
            headerClassName="bg-200 text-nowrap align-middle"
            rowClassName="align-middle white-space-nowrap"
            tableProps={{
              bordered: true,
              striped: true,
              className: "fs-10 mb-0 overflow-hidden",
            }}
          />
        </AdvanceTableWrapper>
      ) : (
        <div className="border p-2 rounded text-center">
          {" "}
          Data is not Available <NoData />
        </div>
      )}
    </div>
  );
}

export default Orders;
